import { render, staticRenderFns } from "./CourseInvitations.vue?vue&type=template&id=e9bfab36&"
import script from "./CourseInvitations.vue?vue&type=script&lang=js&"
export * from "./CourseInvitations.vue?vue&type=script&lang=js&"
import style0 from "./CourseInvitations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports